import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import { stringify } from 'querystring';
import { HelperFunctions } from '@/helpers';
import { Params } from '@/constants';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '@/services';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        idToken: '',
        refreshToken: '',
        JWT: '',
        errorCode: '',
        oidcAuthInProgress: false,
    },
    mutations: {
        UPDATE_ID_TOKEN(state, idToken: string) {
            state.idToken = idToken;
        },
        UPDATE_REFRESH_TOKEN(state, refreshToken: string) {
            state.refreshToken = refreshToken;
        },
        UPDATE_JWT(state, JWT: string) {
            state.JWT = JWT;
        },
        UPDATE_ERROR_CODE(state, errorCode: string) {
            state.errorCode = errorCode;
        },
        UPDATE_OIDC_AUTH(state, inProgress: boolean) {
            state.oidcAuthInProgress = inProgress;
        },
    },
    actions: {
      async getUrlToken({ commit }) {
        const authCode = HelperFunctions.getUrlParameter(Params.AUTH_CODE);
        const JWT = HelperFunctions.getUrlParameter(Params.URL_PARAM_KEY);
        const refreshToken = HelperFunctions.getUrlParameter(Params.REFRESH_TOKEN);
        const oidcProvider = HelperFunctions.getUrlParameter(Params.IDENTITY_PROVIDER);

        // internal okta
        if (authCode && process.env.VUE_APP_COGNITO_OAUTH_CLIENT_ID === 'undefined') {
          const data = {
            grant_type: 'authorization_code',
            redirect_uri: `${window.location.origin}${window.location.pathname}`,
            client_id: process.env.VUE_APP_COGNITO_CLIENT_ID,
            code: authCode,
          };
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
          };
          await axios.post(
            `https://${process.env.VUE_APP_COGNITO_OAUTH_URL}/oauth2/token`, stringify(data), { headers },
          ).then((RESPONSE) => {
            localStorage.setItem('idToken', RESPONSE.data.id_token);
            localStorage.setItem('refreshToken', RESPONSE.data.refresh_token);
            commit('UPDATE_ID_TOKEN', RESPONSE.data.id_token);
            commit('UPDATE_REFRESH_TOKEN', RESPONSE.data.refresh_token);
            return RESPONSE;
          }).catch((e) => {
              commit('UPDATE_ERROR_CODE', e);
              return e;
          });
        } else if (authCode && process.env.VUE_APP_COGNITO_OAUTH_CLIENT_ID !== 'undefined') { // completed oidc auth
            commit('UPDATE_OIDC_AUTH', true);
        } else if (oidcProvider) { // partner oidc
            AuthService.deleteCookie();
            localStorage.clear();
            await Auth.federatedSignIn({
                customProvider: `${process.env.VUE_APP_COGNITO_PARTNER_PROVIDER}`,
            });
        } else if (JWT) {
            localStorage.setItem('idToken', JWT);
            commit('UPDATE_ID_TOKEN', JWT);
            localStorage.setItem('refreshToken', refreshToken);
            commit('UPDATE_REFRESH_TOKEN');
            return JWT;
            }
        },
    },
    getters: {
        idToken(state): string {
            return state.idToken;
        },
        refreshToken(state): string {
            return state.refreshToken;
        },
        JWT(state): string {
            return state.JWT;
        },
        errorCode(state): string {
            return state.errorCode;
        },
        oidcInProgress(state): boolean {
            return state.oidcAuthInProgress;
        },
    },
});
